import React from 'react';
import { ParagraphSmallBold } from 'lib/components/styles/typography';
import { IntegrationsList } from '../main/style';
import { Integration } from '../components';
import selectors from '../../../../cypress/selectors';
import { useTranslation } from 'react-i18next';
import { IntegrationProps } from 'lib/api/integrations/types';

interface IntegrationListProps {
  integrations: IntegrationProps[];
}

export const IntegrationList = ({ integrations }: IntegrationListProps) => {
  const { t } = useTranslation();

  return !integrations?.length ? (
    <div>
      <ParagraphSmallBold
        data-cy={selectors.integrationsPage.integrationsNoResults}
      >
        {t('There are no integrations to show.')}
      </ParagraphSmallBold>
    </div>
  ) : (
    <IntegrationsList data-cy={selectors.integrationsPage.integrationsList}>
      {integrations.map((item, index) => {
        return <Integration key={index} integration={item} />;
      })}
    </IntegrationsList>
  );
};
